import { sidebarPage } from '../utils/sidebarPageLayout.js';

function cupCard({ badge, name, host, dates, icon = '🏆' }) {
    const badgeHtml = badge ? `<div class="fg-cup-card__badge">${badge}</div>` : '';
    return `
        <article class="fg-cup-card" data-tournament="${name.replace(/"/g, '&quot;')}">
            <div class="fg-cup-card__banner" aria-hidden="true">${icon}</div>
            <div class="fg-cup-card__body">
                ${badgeHtml}
                <h3 class="fg-cup-card__name">${name}</h3>
                <p class="fg-cup-card__meta">${host}</p>
                <p class="fg-cup-card__dates">${dates}</p>
            </div>
        </article>
    `;
}

function cupSection(titleClass, title, cards) {
    return `
        <section class="fg-shop-category">
            <h2 class="fg-cup-section__title ${titleClass}">${title}</h2>
            <div class="fg-cup-grid">${cards.join('')}</div>
        </section>
    `;
}

export class Cups {
    constructor(containerId) {
        this.containerId = containerId;
    }

    init() {
        const el = document.getElementById(this.containerId);
        if (!el) return;

        const fifa = cupSection('fg-cup-section__title--fifa', 'FIFA Tournaments', [
            cupCard({
                badge: 'FLAGSHIP',
                name: 'FIFA WWC 2027',
                host: '🇧🇷 Brazil',
                dates: 'June 24 – July 25, 2027'
            }),
            cupCard({ name: 'FIFA U-20 WWC 2026', host: 'Host: Coming Soon', dates: 'Sep 2026' }),
            cupCard({ name: 'Olympic Football 2028', host: '🇺🇸 USA', dates: 'July 14 – July 30, 2028', icon: '🏅' }),
            cupCard({ name: 'FIFA Futsal WWC 2026', host: 'Host: Coming Soon', dates: 'TBD 2026', icon: '⚽' })
        ]);

        const uefa = cupSection('fg-cup-section__title--uefa', 'UEFA Tournaments', [
            cupCard({ name: "UEFA Women's EURO 2025", host: '🇨🇭 Switzerland', dates: 'July 2–27, 2025' }),
            cupCard({ name: 'UEFA U-19 Womens EURO 2025', host: '🇨🇭 Switzerland', dates: 'July 2025' }),
            cupCard({ name: 'UEFA U-17 Womens EURO 2025', host: '🇨🇭 Switzerland', dates: 'July 2025' })
        ]);

        const afc = cupSection('fg-cup-section__title--afc', 'AFC Tournaments', [
            cupCard({ name: "AFC Women's Asian Cup 2026", host: 'Host: Coming Soon', dates: 'TBD 2026' }),
            cupCard({ name: "AFC U-20 Women's Asian Cup 2025", host: 'Host: Coming Soon', dates: 'TBD 2025' })
        ]);

        const conmebol = cupSection('fg-cup-section__title--conmebol', 'CONMEBOL Tournaments', [
            cupCard({ name: 'Copa América Femenina 2026', host: '🇪🇨 Ecuador', dates: 'TBD 2026' }),
            cupCard({ name: "CONMEBOL U-20 Women's Championship 2025", host: 'Host: Coming Soon', dates: 'TBD 2025' })
        ]);

        const concacaf = cupSection('fg-cup-section__title--concacaf', 'CONCACAF Tournaments', [
            cupCard({ name: 'CONCACAF W Gold Cup 2024', host: '🇺🇸 USA', dates: 'Feb 20 – Mar 10, 2024' }),
            cupCard({ name: "CONCACAF U-20 Women's Championship 2025", host: 'Host: Coming Soon', dates: 'TBD 2025' })
        ]);

        const caf = cupSection('fg-cup-section__title--caf', 'CAF Tournaments', [
            cupCard({
                name: "CAF Women's Africa Cup of Nations 2024",
                host: '🇲🇦 Morocco',
                dates: 'July 5–26, 2024'
            })
        ]);

        const ofc = cupSection('fg-cup-section__title--ofc', 'OFC Tournaments', [
            cupCard({ name: "OFC Women's Nations Cup 2024", host: '🇫🇯 Fiji', dates: 'Aug 2024' })
        ]);

        const main = [fifa, uefa, afc, conmebol, concacaf, caf, ofc].join('');

        el.innerHTML = sidebarPage({
            title: 'International Cups',
            subtitle: 'Discover the biggest tournaments in female football',
            main,
            wide: true
        });

        el.querySelectorAll('.fg-cup-card').forEach((card) => {
            card.addEventListener('click', () => {
                const name = card.getAttribute('data-tournament');
                window.alert(`Tournament detail page for "${name}" coming soon!`);
            });
        });
    }
}
